import {useLayoutEffect, useRef, useState} from 'react';
import {TDLD, UiAction} from '@cabinetsbycomputer/top-down-layout-designer';

export const useTdldPreview = (roomId) => {
    const [loader, setLoader] = useState(true);
    const tdldInstance = useRef();

    useLayoutEffect(() => {
        if (!roomId) {
            return;
        }

        if (
            typeof tdldInstance.current !== 'undefined' &&
            tdldInstance.current.roomId == roomId
        ) {
            return;
        }

        if (typeof tdldInstance.current !== 'undefined') {
            document.querySelector('.tdld_workspace')?.remove();
        }

        const uiactions = new UiAction({
            userPrompt: () => undefined,
            addMessage: () => undefined,
            showLoading: () => setLoader(true),
            hideLoading: () => setLoader(false),
            displayRoomShapeSelection: (tdld, data) => {
                if (
                    tdld.data.hasOwnProperty('points') &&
                    tdld.data.points.length == 0
                ) {
                    return;
                }

                const layoutRoomShapeId =
                    tdld.data.hasOwnProperty('layoutRoomShapeId') &&
                    tdld.data.layoutRoomShapeId;

                if (!layoutRoomShapeId) {
                    return;
                }

                const layout = data.find(
                    (shape) => shape.id == layoutRoomShapeId
                );

                if (layout) {
                    tdld.onShapeSelected(layout);
                }
            },
        });

        const tdld = new TDLD('#tdld-container', parseInt(roomId), {
            urlBase: '/api/tdld/',
            uiactions,
        });

        const startRoomChangeManager = tdld._startRoomChangeManager.bind(tdld);
        tdld._startRoomChangeManager = (...args) => {
            startRoomChangeManager(...args);
            tdld.cm._options.readOnly = true;
            tdld.cm._options.report_warn = () => undefined;
        };

        tdldInstance.current = tdld;
        tdldInstance.current.filter.rotateForPortraitPage = true;

        window.tdld = tdldInstance.current;
        window.scaleMin = 0.0;
    }, [roomId]);

    return {loader};
};
